import { useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useRef, useState } from "react";
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import { useEntityCrud } from "../../hooks/useEntityCrud";
import { toast } from "react-toastify";
import moment from "moment-jalali";
import { slice } from 'lodash';
import $ from 'jquery';
import AvatarEditor from 'react-avatar-editor';
import InputRange from 'react-input-range';

const Update = () => {

    const { id } = useParams();

    const { readDataById } = useEntityCrud('Advertisements/getAdvertisement');
    const { updateDate } = useEntityCrud('Advertisements/updateAdvertisement');

    const [expireDate, setExpireDate] = useState("")
    const [insertDate, setInsertDate] = useState("")
    const [title, setTitle] = useState("")
    const [image, setImage] = useState("")

    const editor = useRef();
    const [imageSrc,setImageSrc] = useState('');
    const [zoom,setZoom] = useState(1.5);
    const [width,setWidth] = useState(0);
    const [height,setHeight] = useState(0);
    const [radius,setRadius] = useState(0);

    const inputRef = useRef()
    const navigate = useNavigate();

    function convertToDate(date) {
        if (!date)
            return ""
        return moment(`${date.year}/${date.month}/${date.day}`, "jYYYY/jMM/jDD").format("YYYY-MM-DDTHH:mm:ss.SSSZ")
    }

    function getToday() {
        const today = moment().format("jYYYY-jMM-jDD").split("-")
        return {
            year: +today[0],
            month: +today[1],
            day: +today[2]
        }
    }

    function convertDateToInputValue(date) {
        if (!date) return "";
        const shamsiDate = new Date(date).toLocaleDateString("fa-ir-u-nu-latn", {
            year: "numeric",
            month: "2-digit",
            day: "numeric",
        });
        var arr = shamsiDate.split("/");

        return {
            day: parseInt(arr[2]),
            month: parseInt(arr[1]),
            year: parseInt(arr[0]),
        };
    }


    useEffect(() => {
        readDataById(id).then(({ data }) => {
            setImage(`${data.result.image}`);
            setTitle(data.result.title);
            setExpireDate(convertDateToInputValue(data.result.expireDate));
            setInsertDate(convertDateToInputValue(data.result.fromDate));
            $('.addBtn_').addClass("base-group-display");
        });
    }, []);


    const setFileBase64 = async e => {
        const fileData = await toBase64(e.target.files[0]);
        $('.addBtn_').addClass("base-group-display");
        setImage(fileData);
    }

    const toBase64 = async file => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    function handleDelete() {
        $('.addBtn_').removeClass("base-group-display");
        setImage("");
    }



    const handleUpdateBanner = (values) => {
         
        const postedData = {
            "expireDate": convertToDate(expireDate),
            "title": title,
            "image": image,
            "insertDate": convertToDate(insertDate),
            "confirmDate": convertToDate(insertDate),
            "fromDate": convertToDate(insertDate),
            "insertUser": 0,
            "confirmUser": 0,
            "status": true,
        }

        updateDate({ ...postedData, id }).then(({ data }) => {
             
            if (data.status) {
                toast.success(data.message);
                return navigate('/advertiseList');
            } else
                toast.error(data.message);
        })
    }


    const handleBack = () => {
        navigate('/advertiseList', { replace: true });
    }

    const setCurrentFile = async e => {
        const file = e.target.files[0];
        const fileData = await toBase64(file);
        setWidth(800)
        setHeight(380)
        setRadius(0)
        setImageSrc(fileData);
    }

    const downloadImageCropped = () => {
        if(editor){
            const imageData = editor.current.getImageScaledToCanvas().toDataURL('image/jpeg');
            setImage(imageData);
            $('.addBtn_').addClass("base-group-display");
            setTimeout(() => {
                setImageSrc('');
                setZoom(1.5);
                document.getElementById('modal-file-input').value = '';
            },300)
        }
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ویرایش تبلیغ</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="modal fade" id="uploadImage" tabindex="-1" aria-labelledby="uploadImageLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h2 className="modal-title fs-5" id="uploadImageLabel">بارگذاری تصویر</h2>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="fa fa-close"></i></button>
                        </div>
                        <div className="modal-body text-center">
                            <div className={`row ${imageSrc ? 'mb-2' : ''}`}>
                                <div className="col-md-6">
                                    <div className="form-group text-start">
                                        <label>انتخاب تصویر</label>
                                        <input type="file" id="modal-file-input" className="form-control" accept="image/jpeg,image/png" onChange={e => setCurrentFile(e)} />
                                    </div>
                                </div>
                            </div>
                            {!!imageSrc && <>
                                <AvatarEditor ref={editor} image={imageSrc} width={width} height={height} border={20} color={[255,255,255,0.5]} scale={zoom} rotate={0} borderRadius={radius} />
                                <p className="mt-3 text-start">زوم</p>
                                <div dir="ltr" className="mt-1 mb-4"><InputRange maxValue={10} step={0.5} minValue={1} value={zoom} onChange={value => setZoom(value)} /></div>
                            </>}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal">لغو</button>
                            {!!imageSrc && <button type="button" className="btn btn-primary" onClick={downloadImageCropped} data-bs-dismiss="modal">بارگذاری تصویر</button>}
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-body">
                <div className="adItem col-md-12 d-flex">
                    <div className="col-md-3">
                        <div className="adItem addBtn_ " data-bs-toggle="modal" data-bs-target="#uploadImage">
                            <h1>+</h1>
                        </div>
                        <input onChange={setFileBase64} ref={inputRef} type="file" style={{ display: "none" }} />

                        {image && <>
                            <img src={image.includes('base64') ? image : `https://petromah.sabinarya.com/${image}`} />
                            <button onClick={() => handleDelete()} className="delBtn_ ">X</button>
                        </>}

                    </div>
                    <div className="col-md-3 d-flex flex-column justify-content-between">
                        <div>
                            <input
                                type="text"
                                required
                                className="form-control my-1"
                                placeholder=" عنوان ... "
                                onChange={(e) => setTitle(e.target.value)}
                                name="title"
                                value={title} />
                            <DatePicker
                                name="dateExpire"
                                required
                                locale="fa"
                                minimumDate={getToday()}
                                shouldHighlightWeekends
                                value={insertDate}
                                onChange={setInsertDate}
                                className="form-control my-1 pb-4"
                                inputPlaceholder=' از تاریخ ...'
                            />
                            <DatePicker
                                name="dateExpire"
                                required
                                locale="fa"
                                minimumDate={getToday()}
                                shouldHighlightWeekends
                                value={expireDate}
                                onChange={setExpireDate}
                                className="form-control mb-4 pb-4"
                                inputPlaceholder=' تا تاریخ ...'
                            />
                        </div>
                        <button className="btn btn-success px-4 mt-4 btn-block"

                            disabled={
                                !title ||
                                !image ||
                                !expireDate ||
                                !insertDate
                            }

                            onClick={() => handleUpdateBanner()}>ذخیره  </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Update;